import React from "react";
import {observer} from "mobx-react";
import {DayCellBox} from "./boxes/day-cell.box";
import {UnavailableDayNumberComponent} from "./day-number.component";
import styled, {css} from "styled-components";
import {FlightsDatesSelectorModel} from "../../../../../services/flight-search/dates-selection/flights-dates-selector.model";

const DayContentBox = styled(DayCellBox)<{$isInsideSelection: boolean;}>`
    cursor: not-allowed;
    ${props => props.$isInsideSelection
            ? css`
                background-color: ${props => props.theme.colors.light};
            `
            : ''
    }
`

const SoldOutBox = styled.span`
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontSize.caption};
    color: ${props => props.theme.colors.danger};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    height: 100%;
`

interface UnavailableDayComponentProps {
    date: Date;
    flightsDatesSelector: FlightsDatesSelectorModel;
    isSoldOut: boolean;
}

export const UnavailableDayComponent: React.FC<UnavailableDayComponentProps> = observer((props) => {
    const isInsideSelection = props.flightsDatesSelector.isDateInsideSelection(props.date);

    const renderSoldOut = () => {
        if(props.isSoldOut) {
            return <SoldOutBox>Sold Out</SoldOutBox>
        }
        return null;
    }

    return (
        <DayContentBox $isInsideSelection={isInsideSelection}>
            <UnavailableDayNumberComponent date={props.date}/>
            {renderSoldOut()}
        </DayContentBox>
    );
})